import { ChannelkartNetworkDelete, ChannelkartNetworkGet, ChannelkartNetworkPost } from "../../services/networkService";

export async function getUserDefinedSSO():Promise<boolean>{
    try {
        const res = await ChannelkartNetworkGet("/v1/sso/metaconfig");
        const data = res["data"];
        if (data && data["features"] && data["features"].length > 0) {
            return data?.["features"]?.[0]?.["userWiseSSO"] ?? false;
        }
        return false;
    } catch (error) {
        console.error(error);
        return false;
    }
    
}

export async function postUserDefinedSSO(userWiseSSO:boolean):Promise<boolean>{
    try {
        const res = await ChannelkartNetworkPost("/v1/sso/metaconfig",{userWiseSSO});
        return res.status === 201 || res.status === 200;
    } catch (error) {
        console.error(error);
        return false;
    }
}


export async function getRegistrations() {
    const res = await ChannelkartNetworkGet("/v1/sso/saml/registrations");
    if(!res || res.status >=400){
        throw Error("get Registrations api failure");
    }
    return res.data;
}

export async function getBlob(formData: FormData) {
    const response = await ChannelkartNetworkPost(
        "/v1/uploadFile/images",
        formData,
        { "Content-Type": "multipart/form-data" }
    );
    if(!response || response.status >=400){
        throw Error("File upload error");
    }
    return response?.data?.features?.[0]?.Uri ?? null;
}

export function readXml(xmlFile:string):Document|null{

    let xmlDoc: Document | null = null;

    if (typeof window.DOMParser !== "undefined") {
        const xmlhttp: XMLHttpRequest = new XMLHttpRequest();
        xmlhttp.open("GET", xmlFile, false);
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
                const parser: DOMParser = new DOMParser();
                xmlDoc = parser.parseFromString(xmlhttp.responseText, "text/xml");
            }
        };
        xmlhttp.send();
    } else {
        throw Error("DOMParser not supported. Unable to read XML.");
    }
    return xmlDoc;
}

export async function postRegistration(requestBody:Object){
    const res = await ChannelkartNetworkPost("/v1/sso/saml/registrations",requestBody);
    if(!res || res.status >=400){
        const msg = res?.data?.message === "" ? "Error in saving registration":res?.data?.message;
        throw Error(msg);
    }
    return res;
}

export async function deleteRegistration(id:string){
    const res = await ChannelkartNetworkDelete(`/v1/sso/saml/registrations?registrationId=${id}`);
    if(!res || res.status >=400){
        const msg = res?.data?.message?.trim() === "" ? "Error in Deleting data":res?.data?.message;
        throw Error(msg);
    }
    return res;
}